import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import { Location } from './Models';
import { stylesheet } from 'typestyle';
import * as React from 'react';
import store from './Store';
import * as moment from 'moment';


const css = stylesheet({
	formControl: {
		width: '100%',
	},
	pickerContainer: {
		display: 'flex',
	}
})

type State = {
	reportTypeGroup: string
	open: boolean
	selectedLocationId: number
	from: string
	to: string
}

export default class Reports extends React.Component<{
	locations: Array<Location>
}>{

	state: State = {
		reportTypeGroup: '',
		open: false,
		selectedLocationId: 0,
		from: moment().subtract('months', 3).format('YYYY-MM-DD'),
		to: moment().format('YYYY-MM-DD'),
	};


	handleClickOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({
			reportTypeGroup: '',
			open: false,
			selectedLocationId: 0,
		});
	};

	handleChange = (name: string) => (event: React.ChangeEvent<HTMLSelectElement>) => {
		console.log(name, event.target.value)
		this.setState({ [name]: event.target.value });
	};

	handleExport = () => window.location.href = `/api/reports/${this.state.reportTypeGroup}/${store.viewId}?locationid=${this.state.selectedLocationId}&from=${this.state.from}&to=${this.state.to}`



	render() {
		return (<>
			<Button onClick={this.handleClickOpen}>
				Reports
			</Button>

			<Dialog
				open={this.state.open}
				onClose={this.handleClose}
				aria-labelledby="form-reports-title"
			>
				<DialogTitle id="form-reports-title">Export data from the database</DialogTitle>
				<DialogContent>
					<form>
						<FormControl className={css.formControl}>
							<InputLabel htmlFor="selected-location-id">Location</InputLabel>
							<Select
								value={this.state.selectedLocationId}
								onChange={this.handleChange('selectedLocationId')}
								inputProps={{
									id: 'selected-location-id',
									name: 'selectedLocationId',
								}}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								{this.props.locations.map(l => <MenuItem key={l.id} value={l.id}>{l.name}</MenuItem>)}
							</Select>
						</FormControl>
						<FormControl className={css.formControl}>
							<InputLabel htmlFor="report-type-group">Report type</InputLabel>
							<Select
								value={this.state.reportTypeGroup}
								onChange={this.handleChange('reportTypeGroup')}
								inputProps={{
									id: 'report-type-group',
									name: 'reportTypeGroup',
								}}
							>{this.state.from}
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value="oxygen">Oxygen</MenuItem>
								<MenuItem value="ph">pH</MenuItem>
								<MenuItem value="temperature">Temperature</MenuItem>
								<MenuItem value="depth">Depth</MenuItem>
							</Select>
						</FormControl>
						<div className={css.pickerContainer}>
							<FormControl className={css.formControl}>
								<TextField
									value={this.state.from}
									defaultValue={this.state.from}
									onChange={this.handleChange('from')}
									label="From"
									type="date"
									InputLabelProps={{
										shrink: true,
									}}
								/>
							</FormControl>
							<FormControl className={css.formControl}>
								<TextField
									value={this.state.to}
									defaultValue={this.state.to}
									onChange={this.handleChange('to')}
									label="To"
									type="date"
									InputLabelProps={{
										shrink: true,
									}}
								/>
							</FormControl>
						</div>
					</form>

				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleClose} color="secondary">
						Cancel
					</Button>
					<Button disabled={(this.state.selectedLocationId === 0 || this.state.reportTypeGroup === '' || this.state.from === '' || this.state.to === '')} color="primary" onClick={this.handleExport} target="_blank">
						Export
					</Button>
				</DialogActions>
			</Dialog>

		</>);
	}
}


// WEBPACK FOOTER //
// ./src/Reports.tsx